// extracted by mini-css-extract-plugin
export default {"page":"Ji-z","cartModal":"Ki-z","checkout":"Li-z","placeholder":"Mi-z","account":"Ni-z"};